import { defineStore } from 'pinia';

interface ApplicationUpdateState {
  loadedVersion: string | null;
  mismatchedVersion: string | null;
  noticeTriggered: boolean;
  workspaceActive: boolean;
}

export const useApplicationUpdateStore = defineStore('applicationUpdate', {
  state: (): ApplicationUpdateState => ({
    loadedVersion: readLoadedApplicationVersion(),
    mismatchedVersion: null,
    noticeTriggered: false,
    workspaceActive: false
  }),
  actions: {
    observeServerVersion(version: string): void {
      const normalizedVersion = version.trim();
      if (normalizedVersion.length === 0) {
        return;
      }

      if (this.loadedVersion == null) {
        this.loadedVersion = normalizedVersion;
        return;
      }

      if (normalizedVersion === this.loadedVersion) {
        return;
      }

      this.mismatchedVersion = normalizedVersion;
      this.triggerNoticeWhenReady();
    },
    setWorkspaceActive(active: boolean): void {
      this.workspaceActive = active;
      this.triggerNoticeWhenReady();
    },
    triggerNoticeWhenReady(): void {
      if (!this.noticeTriggered && this.workspaceActive && this.mismatchedVersion != null) {
        this.noticeTriggered = true;
      }
    }
  }
});

function readLoadedApplicationVersion(): string | null {
  const version = document.querySelector<HTMLMetaElement>('meta[name="knowledge-base-version"]')?.content.trim();
  return version != null && version.length > 0 && !version.includes('%VITE_') ? version : null;
}
